export function normalizeHex(v: string | undefined | null) {
    if (!v) return '#000000'
    let s = String(v).trim()
    if (!s.startsWith('#')) s = '#' + s
    s = s.toLowerCase()
  
    const m3 = s.match(/^#([0-9a-f]{3})$/i)
    if (m3) {
      const t = m3[1]
      s = `#${t[0]}${t[0]}${t[1]}${t[1]}${t[2]}${t[2]}`
    }
  
    if (!/^#[0-9a-f]{6}$/i.test(s)) return '#000000'
    return s
  }
  
  export function rgbToHex(r: number, g: number, b: number) {
    const to = (n: number) => n.toString(16).padStart(2, '0')
    return `#${to(r)}${to(g)}${to(b)}`
  }
  
  export function hexToRgb(hex: string) {
    const m = hex.replace('#', '').trim()
    if (m.length !== 6) return null
    const r = parseInt(m.slice(0, 2), 16)
    const g = parseInt(m.slice(2, 4), 16)
    const b = parseInt(m.slice(4, 6), 16)
    return { r, g, b }
  }
  